import {currentPage} from '../common/layout';
import { getM1FindVehicleEu, getM1FindVehicleUs, getM1FindVehicleByType } from '../common/shop/m1-find-vehicle-widget-loader';
// import '../common/jquery.sticky';

currentPage.pageInit = ($page, pageData, pageId) => {
    let currentEdition = document.querySelector('body').dataset.edtn;
    // $(".sidebar").stickySidebar({containerSelector: ".content-area"});

      getM1FindVehicleEu().then((api) => {
        api.m1FindVehicleEu();
      });
      getM1FindVehicleUs().then((api) => {
        api.m1FindVehicleUs();
      });
      getM1FindVehicleByType().then((api) => {
        api.m1FindVehicleByType();
      });
}